/* eslint-disable @typescript-eslint/no-unsafe-return,@typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { ApolloClient as ApolloClientType, gql } from '@apollo/client'
import algoliasearch from 'algoliasearch/lite'
import { findResultsState } from 'react-instantsearch-dom/server'

import { APP_ID as ALGOLIA_APP_ID } from '../components/algolia/AlgoliaSearch'
import { Refinement } from '../components/search/DynamicFilters'

const FRAGMENT_NAME = 'InitialResults'
const KEY = 'initalResults'

type Node = {
  __typename: string
  id: string
}

export type AlgoliaItem = {
  __typename:
    | 'ComponentWebElementsAttendeeSearchSidebarFilters'
    | 'ComponentWebElementsScheduleSearchSidebarFilters'
    | 'ComponentWebElementsCompanySearchSidebarFilters'
  apiKey: string
  conferenceId?: string | null
  hitsPerPage?: number
  id: string
  indexName: string
  refinements?: Refinement[]
}

// eslint-disable-next-line @typescript-eslint/ban-types
export type ApolloClient = ApolloClientType<object>

export function writeResults<T = any>(apolloClient: ApolloClient, item: Node, results: T) {
  apolloClient.writeFragment({
    data: { [KEY]: JSON.stringify(results) },
    fragment: gql`
      fragment ${FRAGMENT_NAME}${item.id} on ${item.__typename} { ${KEY} }
    `,
    id: `${item.__typename}:${item.id}`,
  })
}

export function readResults<T = any>(apolloClient: ApolloClient, item: Node): T | undefined {
  const result = apolloClient?.readFragment<{ [KEY]: string }>({
    fragment: gql`
      fragment ${FRAGMENT_NAME}${item.id} on ${item.__typename} { ${KEY} }
    `,
    id: `${item.__typename}:${item.id}`,
  })
  return result ? JSON.parse(result[KEY]) : undefined
}

export async function prepareResults<T>(
  apolloClient: ApolloClient,
  component: React.ComponentType<T>,
  item: AlgoliaItem
) {
  const searchClient = algoliasearch(ALGOLIA_APP_ID, item.apiKey)
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const resultsState = await findResultsState(component, {
    ...item,
    appId: ALGOLIA_APP_ID,
    searchClient,
    searchState: {},
  })
  writeResults(apolloClient, item, resultsState)
}
